import { I18n } from "@assets/strings";
import React from "react";
import { Redirect } from "@core/routing/redirect";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useQuiz, useQuizParticipantAnswer } from "@domain/lms/quiz/hooks";
import { useIsMobile } from "@utils/hooks";
import { Page } from "@ui/components/page";
import { QuizView } from "@ui/components/quiz/quizView";
import { NotFoundPage } from "@ui/pages/notFoundPage";

interface QuizViewPageProps extends React.HTMLAttributes<HTMLDivElement> {
	quizId: string;
	source?: string;
}
export const QuizViewPage: React.FC<QuizViewPageProps> = ({ quizId, source, ...htmlProps }) => {
	const { result: quiz, loading, error } = source ? useQuizParticipantAnswer(quizId, source) : useQuiz(quizId);
	const isMobile = useIsMobile();

	if (!isMobile) {
		return <Redirect to={Path.Quiz(quizId, false)} />;
	}
	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.quiz")} />;
	}
	if (!quiz) {
		return loading ? <ClipLoader /> : null;
	}

	return (
		<Container {...htmlProps}>
			<QuizView quiz={quiz} isAuthor={source ? true : false} onFinish={() => window.scrollTo(0, 0)} />
		</Container>
	);
};

const Container = styled(Page)``;
